import { render, staticRenderFns } from "./MarketplaceIndex.vue?vue&type=template&id=4a1e3440&scoped=true"
import script from "./MarketplaceIndex.vue?vue&type=script&lang=js"
export * from "./MarketplaceIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceIndex.vue?vue&type=style&index=0&id=4a1e3440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e3440",
  null
  
)

export default component.exports